import { render, staticRenderFns } from "./AdminCreateAccount.vue?vue&type=template&id=0543d372&"
import script from "./AdminCreateAccount.vue?vue&type=script&lang=js&"
export * from "./AdminCreateAccount.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreateAccount.vue?vue&type=style&index=0&id=0543d372&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports